// extracted by css-extract-rspack-plugin
export default {"paginationToolbar":"gE8m6","unavailableCursor":"YqujR"};